<!-- Read-only before -> transaction -> after view (mirrors the Hedge Matrix After State Preview).
     Copy is intentionally absent — the ONLY broker path is the grid's existing right-click copy
     (FR-92/93). No prices (owner ruling 2026-06-22). -->
<dx-popup
  [closeOnOutsideClick]="false"
  [width]="1200"
  maxWidth="calc(100vw - 32px)"
  [height]="this.height"
  [showTitle]="true"
  [title]="this.title"
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [showCloseButton]="true"
>
  <div *dxTemplate="let data of 'content'">
    <div class="copilot-tx">

      <div class="tx-content">
        <dx-scroll-view direction="both">

          <div class="tx-row" *ngFor="let row of this.rows" [style.color]="row.color">

            <div class="row-title">
              <div class="hedge-name">{{ row.label }}</div>
            </div>

            <div class="row-data">

              <div class="col before">
                <table>
                  <tr class="group-name"><td colspan="5">Before</td></tr>
                  <tr class="headers">
                    <td>Qty</td><td>Side</td><td>Type</td><td>Expiration</td><td>Strike</td>
                  </tr>
                  <tr *ngFor="let leg of row.before" class="row">
                    <td>{{ leg.qty }}</td>
                    <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                    <td>{{ leg.optionType }}</td>
                    <td>{{ leg.expiry | etsFriendlyDatePipe:(referenceDateFor(row) ? 'full' : ''):referenceDateFor(row) }}</td>
                    <td>{{ leg.strike }}</td>
                  </tr>
                  <tr *ngIf="row.before.length === 0" class="empty"><td colspan="5">&mdash; None &mdash;</td></tr>
                </table>
              </div>

              <div class="col transaction">
                <table>
                  <tr class="group-name"><td colspan="4">Transaction</td></tr>
                  <tr class="headers">
                    <td>Action</td><td>Qty</td><td>Expiration</td><td>Strike</td>
                  </tr>
                  <tr *ngFor="let leg of row.transaction" class="row">
                    <td>{{ leg.action }}</td>
                    <td>{{ leg.qty }}</td>
                    <td>{{ leg.expiry | etsFriendlyDatePipe:(referenceDateFor(row) ? 'full' : ''):referenceDateFor(row) }}</td>
                    <td>{{ leg.strike }}</td>
                  </tr>
                  <tr *ngIf="row.transaction.length === 0" class="empty"><td colspan="4">&mdash;</td></tr>
                </table>
              </div>

              <div class="col after">
                <table>
                  <tr class="group-name"><td colspan="5">After</td></tr>
                  <tr class="headers">
                    <td>Qty</td><td>Side</td><td>Type</td><td>Expiration</td><td>Strike</td>
                  </tr>
                  <tr *ngFor="let leg of row.after" class="row">
                    <td>{{ leg.qty }}</td>
                    <td>{{ leg.qty | etsQtyToMarketSide }}</td>
                    <td>{{ leg.optionType }}</td>
                    <td>{{ leg.expiry | etsFriendlyDatePipe:(referenceDateFor(row) ? 'full' : ''):referenceDateFor(row) }}</td>
                    <td>{{ leg.strike }}</td>
                  </tr>
                  <tr *ngIf="row.after.length === 0" class="empty"><td colspan="5">&mdash; Closed &mdash;</td></tr>
                </table>
              </div>

            </div>
          </div>

          <div class="tx-empty" *ngIf="this.rows.length === 0">
            No Position to Display For This Solution.
          </div>

        </dx-scroll-view>
      </div>

      <div class="tx-note">Read-Only. Copy to Broker is Via the Grid's Existing Order Workflow.</div>

      <div class="tx-footer">
        <dx-button text="Close" (onClick)="this.hide()"></dx-button>
      </div>

    </div>
  </div>
</dx-popup>
